import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import Swagger from "../components/Swagger";
import apidoc from '../../cp-api.json';


const IndexPage = () => (
  <Layout>
    <SEO title="CDN" />
    <Swagger spec={apidoc}/>
    {/* <Link to="/">Go back to the homepage</Link> */}
  </Layout>
)

export default IndexPage
